import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  UploadFile,
  UploadProps,
  message,
} from "antd";
import Modal from "antd/lib/modal/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getFilesCategories, pollStatusFileAdmin, validateFile } from "../../../core/store/reducers/files.slice";
import Upload, { RcFile } from "antd/lib/upload";
import { uploadFilePath, uploadFilePathAdmin } from "../../../core/store/reducers/upload.slice";
import { readAsArrayBufferAsync } from "./admin-document-upload.components";
import axios from "axios";
import { convertFileSizeFromBytes } from "../../../shared/utilities";
import PopupMessageComponent from "../../../shared/layouts/message.layout";

function UploadFileComponent({ formVisible, setFormVisible, reloadList }: any) {
  const dispatch = useDispatch();
  const [listData, setListData] = useState([] as any);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileListData, setFileListData] = useState([] as any);
  const [errorFileListData, setErrorFileListData] = useState([] as any);
  const [uploading, setUploading] = useState(false);
  const [filename, setFilename] = useState(null as any);
  const [categoryId, setCategoryId] = useState(null as any);
  const [selectedTemplateUrl, setSelectedTemplateUrl] = useState(null as any);
  const [modalVisible, setModalVisible] = useState(false as any);
  const [modalType, setModalType] = useState("" as any);
  const [modalButtons, setModalButtons] = useState((<></>) as any);
  const [modalTitle, setModalTitle] = useState("" as any);
  const [modalSubTitle, setModalSubTitle] = useState("" as any);
  const [startProcessing, setStartProcessing] = useState(false as any);

  useEffect(() => {
    dispatch(getFilesCategories({})).then((val: any) => {
      if (val?.payload?.data?.data) {
        setListData(val?.payload?.data?.data);
      }
    });
  }, []);
  const handleUpload = async (file: any, ext: string) => {
    try {
      const response = await dispatch(
        uploadFilePathAdmin({
          filename: filename,
          category_id: categoryId
        })
      );
      
      if(!response?.payload?.data?.data){
        removeFile();
        message.error("Something went wrong.", 10);
      }
      const {
        data: {
          data: { file_id: upload_id, url },
        },
      } = response.payload;
      try {
        const binaryFile = await readAsArrayBufferAsync(file as RcFile);
        setUploading(true);
        const payload:any = {
          headers: { "Content-Type": file.type || "", "x-ms-blob-type": "BlockBlob" },
          method: "PUT",
          data: binaryFile,
          url: url,
          timeout: 0,
        }
        const fileUploaded = await axios.request(payload);
        if (fileUploaded.status === 200 || fileUploaded.status === 201) {
          setUploading(false);
          setFileListData([{ file, upload_id, url, fileUploaded: fileUploaded }]);
        }
      } catch (e) {
        removeFile();
        setUploading(false);
        message.error("Something went wrong.", 10);
      }
    } catch (e) {
      removeFile();
      setUploading(false);
      message.error("Something went wrong.", 10);
    }
  };
  const removeFile = () => {
    setFileList([]);
    setFileListData([]);
    setErrorFileListData([]);
  };
  const props: UploadProps = {
    showUploadList: false,
    onRemove: (file) => {
      removeFile();
    },
    beforeUpload: (file) => {
      const maxSizeInBytes = 5 * 1024 * 1024; // 2 MB in bytes
      if (file.size > maxSizeInBytes) {
        message.warning("File size must be up to 5 MB", 10);
        setErrorFileListData([{ file }]);
        return false;
      }
      if (fileListData.length >= 2) {
        message.warning("You can only upload max 1 files", 10);
        return false;
      }
      const { name } = file;
      let ext: any = name?.split(".");
      ext = ext?.length > 0 ? ext[ext.length - 1] : "";
      if (["csv"].includes(ext)) {
      } else {
        message.error("Uploaded file is not valid", 10);
        return;
      }

      setFileList([file]);
      setFileListData([{ file }]);
      handleUpload(file, ext);
      return false;
    },
    maxCount: 1,
    fileList,
  };
  const onFormValuesChange = (data: any) => {
    if (data?.filename) {
      setFilename(data?.filename);
      form.setFieldValue("category_id", null);
      setCategoryId(null);
      setFileList([]);
      setFileListData([]);
      setErrorFileListData([]);
    }
    if (data?.category_id) {
      setCategoryId(data?.category_id);
      const category = listData?.filter((val:any)=>val.id == data?.category_id);
      setSelectedTemplateUrl(category[0].template_url)
      setFileList([]);
      setFileListData([]);
      setErrorFileListData([]);
    }
  };
  
  
  const closeModalPopup = () => {
    setModalVisible(false);
    setModalType("");
    setModalButtons(<></>);
    setModalSubTitle("");
    setFormVisible(false);
    setModalTitle("");
    reloadList()
  };
  const openProcessingModal = () => {
    setModalTitle("Processing");
    setModalType("processing");
    setModalSubTitle(<div className="text-center">File has been uploaded successfully and is under processing. <br />Incase of any issues, Error file will be generated.</div>);
    setModalButtons(<></>);
    setModalVisible(true);
    setStartProcessing(true)
  };
  const openSuccessModal = () => {
    setModalTitle("File Uploaded");
    setModalType("success");
    setModalSubTitle("");
    setModalButtons(<></>);
    setModalVisible(true);
  };
  const openErrorModal = (error_file_url: string) => {
    setModalTitle("Error");
    setModalType("error");
    setModalSubTitle(
      <div className="text-center">Seems like there are issues with the uploaded file.
      <br />Error file is generated for your reference.<br />
      Please rectify errors and upload the file again.</div>
        );
    setModalButtons(
      <>
        <Row>
          <Col span={24}>
            <a href={error_file_url}><Button
              size="large"
              type="primary"
              block
            >
              Download Error File
            </Button></a>
          </Col>
        </Row>
      </>
    );
    setModalVisible(true);
  };
  
  const startValidation = async () => {
    const payload = {
      "file_id": fileListData[0].upload_id,
      "file_category_id": categoryId
    }
    const res = await dispatch(validateFile(payload));
    if(res?.payload?.status == 200){
      openProcessingModal()
      pollValidation()
    }else{
      message.error("Some error occured while uploading file", 10)
    }
    
  }
  const pollValidation = async () => {
    const query = {
      "file_id": fileListData[0].upload_id,
    }
    const res = await dispatch(pollStatusFileAdmin(query));
    console.log(res?.payload)
    if(res?.payload?.data?.data?.status == 'Rejected'){
      openErrorModal(res?.payload?.data?.data?.error_file_url)
    }
    
    if(res?.payload?.data?.data?.status == 'Processing'){
      setTimeout(() => {
        pollValidation()
      }, 5000);
    }
    if(res?.payload?.data?.data?.status == 'Success'){
      openSuccessModal()
    }

    
  } 
  return (
    <>
      <Modal
        open={formVisible}
        onCancel={() => setFormVisible(false)}
        footer={false}
        title="Upload File"
        className="modalFormButton form-modal"
        style={{ paddingBottom: "0px" }}
        centered={true}
      >
        <Form
          className="app-form p-4"
          form={form}
          name={"ticket_form"}
          onValuesChange={onFormValuesChange}
        >
          <Row gutter={20} align="bottom">
            <Col span={24}>
              <Form.Item
                label="Enter File Name"
                name="filename"
                rules={[{ required: true, message: "File name is required" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={15}>
              <Form.Item
                label="File Category"
                name="category_id"
                rules={[
                  { required: true, message: "File Category is required" },
                ]}
              >
                <Select>
                  {listData?.length > 0 &&
                    listData?.map((val: any) => (
                      <Select.Option value={val.id}>
                        {val?.file_category}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={9}>
              {selectedTemplateUrl && <a href={selectedTemplateUrl}><Button className="mb-3" block type="primary" disabled={!categoryId}>Download Template</Button></a>}
              {!selectedTemplateUrl && <Button className="mb-3" block type="primary" disabled={!categoryId}>Download Template</Button>}
            </Col>
            <Col span={24}>
              {fileListData?.length == 0 && errorFileListData?.length == 0 && (
                <div className="admin-upload-component p-4">
                  <img
                    src={
                      require("../../../assets/icons/cloud-upload.svg").default
                    }
                    width="140"
                  />
                  <p className="title m-0">Upload CSV File</p>
                  <p className="sub-text m-0">(Max file size allowed 5Mb)</p>
                  <Upload {...props}>
                    <Button
                      disabled={!(filename && categoryId && filename != "")}
                      loading={uploading}
                      type="primary"
                      className="mt-4"
                    >
                      Select File
                    </Button>
                  </Upload>
                </div>
              )}
              {(fileListData?.length == 1 ||
                errorFileListData?.length == 1) && (
                <>
                  <div className="ant-form-item-label">
                    <label>CSV File</label>
                  </div>
                  <div
                    className={`admin-file-component ${
                      errorFileListData?.length == 1 ? "danger" : ""
                    }`}
                  >
                    <Row align="middle" gutter={12} className="pb-2">
                      <Col flex="none">
                        <img
                          src={
                            require("../../../assets/icons/file-type-excel.svg")
                              .default
                          }
                          height={50}
                        />
                      </Col>
                      <Col flex="auto">
                        <p className="title m-0">
                          {fileListData[0]?.file?.name ||
                            errorFileListData[0]?.file?.name}
                        </p>
                        <p className="sub-text m-0">
                          {convertFileSizeFromBytes(
                            fileListData[0]?.file?.size ||
                              errorFileListData[0]?.file?.size
                          )}{" "}
                          {fileListData?.length == 1 && `• File Uploaded`}
                        </p>
                      </Col>
                      <Col flex="none">
                        <Row>
                          <Col>
                            <Button
                              type="link"
                              onClick={removeFile}
                              icon={
                                <img
                                  src={
                                    require("../../../assets/icons/close.svg")
                                      .default
                                  }
                                />
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            {fileListData?.length == 1 && !fileListData[0].upload_id && (
                              <span className={`percent success`}>0%</span>
                            )}
                            {fileListData?.length == 1 && fileListData[0].upload_id && (
                              <span className={`percent success`}>100%</span>
                            )}
                            {errorFileListData?.length == 1 && (
                              <span className={`percent danger`}>Failed</span>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <div
                          className={`progress-bar ${
                            fileListData?.length == 1 && fileListData[0].upload_id ? "success" : ""
                          } ${errorFileListData?.length == 1 ? "danger" : ""}`}
                        ></div>
                      </Col>
                    </Row>
                  </div>
                  {errorFileListData?.length == 1 && (
                    <Row>
                      <Col className={`admin-error-message pt-2`} span={24}>
                      Error: File size is too large to be uploaded. Files larger
                      than <br />
                      5mb size are not supported.
                      </Col>
                    </Row>
                      
                  )}
                </>
              )}
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col span={20}>
                  <Button
                    type="primary"
                    className="mt-4"
                    size="large"
                    disabled={
                      !(
                        filename &&
                        categoryId &&
                        filename != "" &&
                        fileListData?.length > 0 &&
                        fileListData[0]?.upload_id
                      )
                    }
                    block
                    onClick={startValidation}
                  >
                    Upload File
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>
      {modalVisible && (
        <PopupMessageComponent
          open={modalVisible}
          onCancel={closeModalPopup}
          title={modalTitle}
          subTitle={modalSubTitle}
          type={modalType}
          buttons={modalButtons}
        />
      )}
    </>
  );
}
export default UploadFileComponent;
